export default defineNuxtPlugin((nuxtApp: any) => {
    if (process.client) {
        nuxtApp.$router.beforeEach((to: any, from: any, next: any) => {
            const token = localStorage.getItem("token");

            // Kullanıcı giriş yapmışsa ve 'giris-yap', 'uye-ol', veya 'sifremi-unuttum' sayfasına gitmek istiyorsa ana sayfaya yönlendir.
            if (token && (to.path.includes('giris-yap') || to.path.includes('uye-ol') || to.path.includes('sifremi-unuttum'))) {
                window.location.href = '/';
            }
            // Kullanıcı giriş yapmamışsa ve profil ile ilgili bir sayfaya gitmeye çalışıyorsa 'giris-yap' sayfasına yönlendir.
            else if (!token && to.path.startsWith('/profil')) {
                // next('/giris-yap');
                window.location.href = '/giris-yap';
            }
            // Kullanıcı giriş yapmışsa ve '/profil' URL'sine gitmek istiyorsa, onları '/profil/kisisel-bilgilerim' sayfasına yönlendir.
            else if (token && to.name === 'profil') {
                // next('/profil/kisisel-bilgilerim');
                window.location.href = '/profil/kisisel-bilgilerim';
            }
            // Kullanıcı giriş yapmışsa ve '/profil' ile başlayan ama tanımlanmamış bir sayfaya gitmek istiyorsa, onları '/profil/kisisel-bilgilerim' sayfasına yönlendir.
            else if (token && to.path.startsWith('/profil') && !nuxtApp.$router.hasRoute(to.name)) {
                window.location.href = '/profil/kisisel-bilgilerim';
            }
            // Diğer durumlar için
            else {
                next();
            }
        });
    }
});
